<template>
    <div>
        <!-- Importação Modal -->
        <div class="modal fade" id="importResultModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Importar Resultados</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-secondary" v-if="marcacao">
                            {{ marcacao.nome_paciente }}
                        </div>

                        <az-input
                            class="mb-3"
                            type="button-group"
                            :optionsList="[
                                { id: 'Q', search: 'QR Code Upload' },
                                { id: 'I', search: 'Importar do Laboratório'},
                            ]"
                            optionsData="id"
                            v-model="tipo" />

                        <template v-if="tipo == 'Q'">
                            <div class="alert alert-info">
                                Permita que o paciente realize a leitura do QR Code para que ele faça o envio do arquivo dos resultados.
                            </div>

                            <div v-if="qrCode">
                                <div class="card border-0 shadow-lg card-link">
                                    <div class="card-body text-center bg-light">
                                        <div class="text-center">
                                            <img
                                                :src="
                                                    'https://chart.googleapis.com/chart?cht=qr&chl=' +
                                                    encodeURIComponent(qrCode) +
                                                    '&choe=UTF-8&chs=250x250'
                                                "
                                                class="img-fluid"
                                            />
                                        </div>
                                        <div class="text-center">
                                            Aponte a câmera do celular para o QRCODE.
                                        </div>
                                    </div>
                                    <div class="card-footer d-flex justify-content-between">
                                        <small class="text-muted">{{ qrCode }}</small>
                                        <div>
                                            <a href="#" @click.prevent="copy(qrCode)" class="card-link">
                                                <i class="fa-solid fa-copy"></i>
                                            </a>
                                            <a :href="whatsapp_link_upload" class="card-link" target="_blank" title="Enviar link para o Whatsapp do paciente.">
                                                <i class="fa-brands fa-whatsapp text-success"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-if="tipo == 'I'">
                            
                            <div class="row">
                                <div class="col col-md-6">
                                    <az-input
                                        label="Laboratório"
                                        class="mb-3"
                                        type="select"
                                        icon="fa-solid fa-flask-vial fa-fw"
                                        placeholder="Selecione o Laboratório..."
                                        :optionsList="[
                                            { id: 'labchecap', search: 'Labchecap' },
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="laboratorio" />

                                    <az-input
                                        class="mb-3"
                                        type="button-group"
                                        :optionsList="[
                                            { id: 'L', search: 'Link / QR Code' },
                                            { id: 'C', search: 'Credenciais' } 
                                        ]"
                                        optionsData="id"
                                        v-model="subtipo" />

                                    <template v-if="subtipo == 'L'">
                                        <div class="alert alert-info">
                                            Permita que o paciente realize a leitura do QR Code para integração dos resultados do laboratório. 
                                            Será necessário que ele possua as credenciais de acesso ao portal de resultados do laboratório.
                                        </div>
                                    </template>

                                    <template v-else-if="subtipo == 'C'">
                                        <div class="alert alert-info">
                                            Permita que o paciente realize a digitação de suas credenciais do laboratório para integração dos resultados. 
                                        </div>
                                    </template>
                                </div>
                                <div class="col col-md-6">
                                    <template v-if="subtipo == 'L'">
                                        <div v-if="qrCodeLab">
                                            <div class="card border-0 shadow-lg card-link">
                                                <div class="card-body text-center bg-light">
                                                    <div class="text-center">
                                                        <img
                                                            :src="
                                                                'https://chart.googleapis.com/chart?cht=qr&chl=' +
                                                                encodeURIComponent(qrCodeLab) +
                                                                '&choe=UTF-8&chs=250x250'
                                                            "
                                                            class="img-fluid"
                                                        />
                                                    </div>
                                                    <div class="text-center">
                                                        Aponte a câmera do celular para o QRCODE.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-else-if="subtipo == 'C' && laboratorio">
                                        <div class="row">
                                            <div class="col col-12">
                                                <az-input
                                                    type="text"
                                                    label="Login do Laboratório"
                                                    required
                                                    :validate="validate"
                                                    v-model="credenciais.login" />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col col-12">
                                                <small class="form-text text-muted text-nowrap text-truncate mt-0">Senha do Laboratório</small>
                                                <input 
                                                    type="text" 
                                                    id="password" 
                                                    style="-webkit-text-security: disc;" 
                                                    v-model="credenciais.senha" 
                                                    autocomplete="off"
                                                    class="form form-control" />

                                                <az-input
                                                    v-if="false"
                                                    type="text"
                                                    label="Senha do Laboratório"
                                                    required
                                                    :validate="validate"
                                                    v-model="credenciais.senha" />

                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <template v-if="qrCodeLab && subtipo == 'L'">
                                <div class="card mt-3 mb-0">
                                    <div class="card-body d-flex justify-content-between">
                                        <small class="text-muted">{{ qrCodeLab }}</small>
                                        <div>
                                            <a href="#" @click.prevent="copy(qrCodeLab)" class="card-link" title="Copiar link para a área de transferência.">
                                                <i class="fa-solid fa-copy"></i>
                                            </a>
                                            <a :href="whatsapp_link" class="card-link" target="_blank" title="Enviar link para o Whatsapp do paciente.">
                                                <i class="fa-brands fa-whatsapp text-success"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="tipo == 'I' && subtipo == 'C' && laboratorio" @click="obter()">Obter</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            marcacao: null, 
            tipo: "Q", 
            subtipo: "C", 
            laboratorio: "labchecap",
            credenciais: { 
                origem: 'labchecap',
                login: null,
                senha: null,
            },
            validate: false, 
            qrCode: null, 
            token: "", 
            telefones: null,
        };
    }, 

    components: { 
        AzInput,
        AzSubmit,
    },

    computed: { 
        qrCodeLab: function() { 
            if ( !this.laboratorio || !this.marcacao || !this.marcacao.id_marcacao || !this.token )
                return '';

            return 'https://' + window.redir + '.klingo.app/#/resultado/exames/' + this.laboratorio + '/' + this.marcacao.id_marcacao + '/' + this.token;
        },
        whatsapp_link: function() { 
            let celular = _.get(this.telefones, 'celular');
            return "https://wa.me/" + celular + "?text=" + encodeURIComponent(this.qrCodeLab);
        },

        whatsapp_link_upload: function() { 
            let celular = _.get(this.telefones, 'celular');
            return "https://wa.me/" + celular + "?text=" + encodeURIComponent(this.qrCode);
        },
    },

    methods: { 
        copy(texto) { 
            this.$util.copiar_clipboard (this, texto, 'Link copiado.');
        },

        abrir(marcacao) { 
            this.marcacao = _.cloneDeep(marcacao);

            this.obterQrCode();

            this.credenciais.login = "";
            this.credenciais.senha = "";
            this.validate = false;
            
            $('#importResultModal').modal('show');
        },

        obter() { 
            this.$util.atualizar(this, { 
                service: 'terceiros',
                func: 'obter_resultados',
                dados: { 
                    id_marcacao: this.marcacao.id_marcacao, 
                    origem: 'labchecap',
                    laboratorio: this.laboratorio, 
                    ...this.credenciais,
                },
                toast: true,
                modal: 'importResultModal'
            });
        },

        obterQrCode() {
            this.$store.commit("loading", true);

            this.axios
                .post("/fupload/token", { model_type: "App\\Models\\Marcacao", model_id: this.marcacao.id_marcacao, celular: true })
                .then(res => {
                    if (res.response && res.response.status > 400) {
                        this.status = res.response.data;
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.response.data,
                            life: 3000
                        });
                    } else {
                        this.$nextTick(() => {
                            this.token = res.data.token;
                            this.qrCode = res.data.link;
                            this.telefones = res.data.telefones;
                        });

                        /*
                        this.canal = this.$store.state.dominio + '-' + res.data.token + '-arq-celular';

                        subscribe(this.canal, "recarregar-arquivo", () => { 
                            this.$emit("refresh");
                        });

                        $('#' + this.modal_id).on('hidden.bs.modal', () => {
                            if ( this.canal ) { 
                                window.Echo.leaveChannel(this.canal);
                            }
                        });
                        */
                    }
                })
                .catch(err => {
                    alert(err);
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        },
    }
}
</script>